import { DashboardHooks, useUsers } from '@partiu/api/dashboard/hooks.ts';
import { DataTablePage } from '../components/templates/DataTablePage.tsx';
import {
  DataGridCPFFormatter,
  DataGridCurrencyFormatter,
  DataGridDateTimeFormatter,
  DataGridNumberFormatter,
} from '../formatters.ts';

export function LoginsLogsPage() {
  return (
    <DataTablePage
      modelName={'Logs de Login e Termos'}
      listQueryKey={DashboardHooks.Users}
      listHook={useUsers}
      searchPlaceholder={'Nome, Email ou CPF'}
      canGenerateReport="users-dashboard"
      canExport={false}
      columns={[
        { field: 'fullName', headerName: 'Nome', flex: 1, minWidth: 200 },
        { field: 'cpf', headerName: 'CPF/CNPJ', width: 150, valueFormatter: DataGridCPFFormatter },
        { field: 'email', headerName: 'Email', flex: 1, minWidth: 220 },
        { field: 'usage', headerName: 'Utilização', width: 120, valueFormatter: DataGridNumberFormatter },
        {
          field: 'saved',
          headerName: 'Total Economizado',
          width: 160,
          valueFormatter: DataGridCurrencyFormatter,
        },
        {
          field: 'createdAt',
          headerName: 'Membro desde',
          width: 200,
          valueFormatter: DataGridDateTimeFormatter,
        },
        {
          field: 'termsAcceptedAt',
          headerName: 'Termos aceitos em',
          width: 200,
          valueGetter: ({ row }) => row.termsAcceptedAt ?? row.createdAt,
          valueFormatter: DataGridDateTimeFormatter,
        },
      ]}
    />
  );
}
